export type TerminalRuntimeConfigKey =
  | "VITE_API_URL"
  | "VITE_INNOVATION_API_BASE_URL"
  | "VITE_INNOVATION_ORG_ID"
  | "VITE_PARTICIPANT_PREVIEW_URL";

function getBuildTimeConfigSource(): Record<
  TerminalRuntimeConfigKey,
  string | undefined
> {
  return {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_INNOVATION_API_BASE_URL: import.meta.env.VITE_INNOVATION_API_BASE_URL,
    VITE_INNOVATION_ORG_ID: import.meta.env.VITE_INNOVATION_ORG_ID,
    VITE_PARTICIPANT_PREVIEW_URL: import.meta.env.VITE_PARTICIPANT_PREVIEW_URL,
  };
}

function getRuntimeConfigSource(): Record<string, string | undefined> {
  const buildTimeConfig = getBuildTimeConfigSource();

  if (typeof window === "undefined") {
    return buildTimeConfig;
  }

  return {
    ...buildTimeConfig,
    ...(window.__APP_CONFIG__ ?? {}),
  };
}

export function getRuntimeConfig(key: TerminalRuntimeConfigKey): string {
  const value = getRuntimeConfigSource()[key];
  return typeof value === "string" ? value.trim() : "";
}

export function getRuntimeConfigFirst(
  keys: TerminalRuntimeConfigKey[],
): string {
  for (const key of keys) {
    const value = getRuntimeConfig(key);
    if (value) {
      return value;
    }
  }

  return "";
}
